import type { IntroducingCardAttributes } from '../../../types/cms'
import { CardsGrid, CardImage, CardTitle } from './styles'
import FormattedImage from '../../FormattedImage'
import { Text } from 'ui-kit'

const IntroducingCard = ({ image, title, info }: IntroducingCardAttributes) => {
  return (
    <CardsGrid item xs={12} sm lg={4}>
      <CardImage>
        <FormattedImage image={image} />
      </CardImage>
      <CardTitle>{title}</CardTitle>
      <Text variant="p" component="p">
        {info}
      </Text>
    </CardsGrid>
  )
}

export default IntroducingCard
